// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid_EDdBl {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-areas: 
  "head head"
  "mid1 mid2"
  "table table";
  grid-template-rows:110px 400px 500px;
  column-gap: 30px;
  row-gap: 30px;
  padding: 30px;
}

.area_YqMC2 { 
  background-color: #f9fafb;
}

.table_VnxdN {
  grid-area: table;
}

.chart1_wF910{
  grid-area: mid1;
}
.chart2_TYdGV{
  grid-area: mid2;
}

.head_ASkFs {
  grid-area: head;
}`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/alerts/Alerts.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B;;;eAGa;EACb,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-areas: \n  \"head head\"\n  \"mid1 mid2\"\n  \"table table\";\n  grid-template-rows:110px 400px 500px;\n  column-gap: 30px;\n  row-gap: 30px;\n  padding: 30px;\n}\n\n.area { \n  background-color: #f9fafb;\n}\n\n.table {\n  grid-area: table;\n}\n\n.chart1{\n  grid-area: mid1;\n}\n.chart2{\n  grid-area: mid2;\n}\n\n.head {\n  grid-area: head;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `grid_EDdBl`,
	"area": `area_YqMC2`,
	"table": `table_VnxdN`,
	"chart1": `chart1_wF910`,
	"chart2": `chart2_TYdGV`,
	"head": `head_ASkFs`
};
export default ___CSS_LOADER_EXPORT___;
